import React from 'react'
import styled from 'styled-components';
import { MainContainer } from '../../components/Contents/Contents.element'
import { useTheme } from '../../contexts/ThemeContext'
import StandardDropdown from '../../ui/StandardDropdown/StandardDropdown';
import PageHeader from '../../layout/PageHeader';
import FinancialBarchart from '../../components/ClubDetail/ClubFinancial/FinancialBarchart';
import ValueGraph from '../../components/ClubDetail/ValueGraph'
// import Tab, { TabItem } from '../../ui/Tab';

const StatCardText = styled.span`
    color: ${({ theme }) => theme.playerColor};
    font-feature-settings: 'clig' off, 'liga' off;

    /* DM-Mono/Display/Large */
    font-family: "DM Mono";
    font-size: 64px;
    font-style: normal;
    font-weight: 500;
    line-height: 64px;
    text-transform: uppercase;
`;

const BookmarkComponent: React.FC<{ toggle: boolean, isSubSidebarOpen: boolean }> = (props) => {
    const { theme } = useTheme();
    const teamsdata: string[] =
        [
            "Men's Snr Team",
            "Women's Snr Team",
            "Men's U21 Team",
            "Women's U21 Team",
            "Men's U18 Team",
            "Women's U18 Team",
            "Women's Snr Team",
            "Men's U21 Team",
            "Women's U21 Team",
            "Men's U18 Team",
            "Women's U18 Team"
        ];
    const options = teamsdata.map(team => ({ value: team }));
    const handleTabSelected = (index: number) => {
        // Perform any other actions based on the selected tab index
    };

    return (
        <MainContainer active={props.toggle} isSubSidebarOpen={props.isSubSidebarOpen}
        className="main-container">
            <PageHeader pageName='bookmark'/>
            {/* <StatCardText>0123456</StatCardText> */}
            {/* <FinancialBarchart/> */}
            {/* <ValueGraph/> */}
           
            {/* <StandardDropdown
                placeholder='Select Team'
                options={options}
            //onClick={() => { handleFilterChange('selectedTeam', selectedFilters.selectedTeam) }}
            //value={selectedFilters.selectedTeam}

            /> */}
            {/* <Tab onTabSelected={handleTabSelected}>
                <TabItem selected={false} onClick={() => { }}>Tab 1</TabItem>
                <TabItem>Tab 2</TabItem>
                <TabItem selected={false} onClick={() => { }}>Tab 3</TabItem>
            </Tab> */}
        </MainContainer>
    )
}

export default BookmarkComponent